import axios, { AxiosError, type InternalAxiosRequestConfig } from "axios";
import { useAuthStore } from "@/stores/auth";
import { router } from "@/router";

export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL ?? "/api").replace(/\/$/, "");

export const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30_000,
});

api.interceptors.request.use((cfg: InternalAxiosRequestConfig) => {
  const auth = useAuthStore();
  if (auth.token) {
    cfg.headers.set("Authorization", `Bearer ${auth.token}`);
  }
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err: AxiosError) => {
    if (err.response?.status === 401) {
      const auth = useAuthStore();
      auth.logout();
      router.push({ name: "login" });
    }
    return Promise.reject(err);
  }
);
